<template>
  <div class="reference-layout">
    <slot></slot>
    <div class="layout">
      <slot name="header"></slot>
      <div>
        <div class="subheader">
          <slot name="subheader"></slot>
        </div>

        <slot name="filters"></slot>

        <slot name="list"></slot>
      </div>
    </div>

    <to-top-button element=".layout"/>
  </div>
</template>

<script>
import ToTopButton from "@/components/to-top-button";

export default {
  name: "reference-layout",
  components: {
    ToTopButton,
  },
  data() {
    return {
      query: "",
    };
  },
  mounted() {
    this.wrapperElement = document.querySelector(".layout");
    this.wrapperElement.addEventListener("scroll", () => {
      this.$emit("layoutScrolled");
    });
  },
  beforeDestroy() {
    this.wrapperElement.removeEventListener("scroll", () => {
      this.$emit("layoutScrolled");
    });
  },
};
</script>

<style lang="scss" scoped>
.reference-layout {
  &__search {
    margin-bottom: 20px;
    flex-grow: 1;

    & /deep/ {
      input::placeholder {
        font-style: italic;
      }
    }
  }
}

#pagetop {
  position: fixed;
  width: 30px;
  height: 30px;
  box-shadow: 0px 2px 10px rgba(0, 15, 38, 0.25);
  border-radius: 50px;
  background: #ffffff;
  right: 10px;
  bottom: 10px;
  border: none;
  outline: none;
}

.layout {
  @media (max-width: 480px) {
    padding: 22px 0 50px 0;
  }
  @media (min-width: 700px) {
    padding: 33px 30px 100px 30px;
  }
}

.reference-layout-page__search,
.layout-header {
  @media (max-width: 480px) {
    padding: 0 20px;
  }
}

.subheader {
  display: flex;
  @media (max-width: 480px) {
    flex-direction: column;
    justify-content: flex-start;
    padding: 0 20px;
  }
}
</style>
